import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ChevronUp, PlusCircle, RotateCcw } from "feather-icons-react/build/IconComponents";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Table from "../../core/pagination/datatable";
import { setToogleHeader } from "../../core/redux/action";
import { api_get, api_post } from "../../helpers/index";
import AddRank from "../../core/modals/spin/addrank";
import Swal from "sweetalert2";

const RankList = () => {
  const [rankList, setRankList] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);

  useEffect(() => {
    handleRetrieveRankList();
  }, []);

  const handleRetrieveRankList = async (keyword = "") => {
    try {
      const response = await api_get(`rank/list?keyword=${keyword}`);
      if (response.status === 1) {
        setRankList(response.data);
      } else {
        console.error("Failed to fetch rank list");
      }
    } catch (error) {
      console.error("Error fetching rank list:", error);
    }
  };

  const handleSearch = (e) => {
    setSearchKeyword(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    handleRetrieveRankList(searchKeyword);
  };

  const handleDeleteRank = async (id) => {
    try {
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      });

      if (result.isConfirmed) {
        const response = await api_post(`rank/delete/${id}`);
        if (response.status === 1) {
          Swal.fire(
            'Deleted!',
            'Rank has been deleted.',
            'success'
          ).then(() => {
            handleRetrieveRankList(searchKeyword);
          });
        } else {
          Swal.fire(
            'Error!',
            'Failed to delete rank.',
            'error'
          );
        }
      }
    } catch (error) {
      console.error("Error deleting rank:", error);
      Swal.fire(
        'Error!',
        'An error occurred while deleting the rank.',
        'error'
      );
    }
  };

  const columns = [
    {
      title: "Rank",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Rank Sequence",
      dataIndex: "rank_sequence",
      key: "rank_sequence",
      sorter: (a, b) => a.rank_sequence - b.rank_sequence,
    },
    {
      title: "Eligible Credit From",
      dataIndex: "eligible_credit_from",
      key: "eligible_credit_from",
      sorter: (a, b) => a.eligible_credit_from - b.eligible_credit_from,
    },
    {
      title: "Eligible Credit To",
      dataIndex: "eligible_credit_to",
      key: "eligible_credit_to",
      sorter: (a, b) => a.eligible_credit_to - b.eligible_credit_to,
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link 
              className="confirm-text barcode-delete-icon" 
              to="#"
              onClick={() => handleDeleteRank(record.rank_id)}
            >
              <i data-feather="trash-2" className="feather-trash-2" />
            </Link>
          </div>
        </div>
      ),
    },
  ];

  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  const renderCollapseTooltip = (props) => (
    <Tooltip id="collapse-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Rank List</h4>
              <h6>Manage your ranks</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                <Link data-bs-toggle="tooltip" onClick={() => handleRetrieveRankList(searchKeyword)}>
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
          <div className="page-btn">
            <Link to="#" className="btn btn-added" data-bs-toggle="modal" data-bs-target="#add-units-category">
              <PlusCircle className="me-2 iconsize" />
              Add New Rank
            </Link>
          </div>
        </div>
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <form onSubmit={handleSearchSubmit} className="search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm formsearch"
                    value={searchKeyword}
                    onChange={handleSearch}
                  />
                  <button type="submit" className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </button>
                </form>
              </div>
            </div>
            <div className="table-responsive">
              <Table 
                columns={columns} 
                dataSource={rankList} 
                rowKey="rank_id"
              />
            </div>
          </div>
        </div>
      </div>
      <AddRank onSuccess={handleRetrieveRankList} />
    </div>
  );
};

export default RankList; 